/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Error } from '../models/Error'
import type { ResponseOrderList } from '../models/ResponseOrderList'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class OrderService {
  /**
   * Zwraca listę zleceń dla klienta
   *
   * @returns ResponseOrderList lista zleceń
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getOrderListFromDukat({
    clientId,
    dateFrom,
    dateTo,
    status,
  }: {
    /**
     * identyfikator klienta
     */
    clientId: number
    /**
     * data od której będą zwracane zlecenia
     */
    dateFrom?: string
    /**
     * data do której będą zwracane zlecenia
     */
    dateTo?: string
    /**
     * statusy zleceń
     */
    status?: Array<number>
  }): CancelablePromise<ResponseOrderList | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/order',
      query: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        clientId: clientId,
        status: status,
      },
    })
  }
}
